import React, { useState } from "react";
import "./UpdateNewFranchiseeCharges.css";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import LoadingSpinner from "../../Loading/component";
import Sidebar from "../../Navigation/Sidebar/Sidebar";

export const UpdateNewFranchiseeCharges = (props) => {
  const navigate = useNavigate();

  const goback = () => navigate(-1);
  const arrowClick = () => navigate(-1);

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="update-new-charges-container">
          <Sidebar />
          
          <div className="charges-content">
            <div className="header-section">
              <img src={leftArrow} alt="Back" onClick={arrowClick} className="back-arrow" />
              <h2 className="page-title">Add new Charges</h2>
            </div>

            <div className="charges-grid">
              <div className="cards-container">
                {props.newCharges?.slice().reverse().map((charge, index) => (
                  <Card key={charge.id} className="charge-card">
                    <div className="card-header">
                      <Typography className="charge-title">
                        Charge Name {index + 1}
                      </Typography>
                      <input
                        type="checkbox"
                        checked={props.selectedChargeIds.includes(charge.id)}
                        onChange={() => props.handleCheckboxChange(charge.id)}
                        className="charge-checkbox"
                      />
                    </div>

                    <CardContent className="card-content">
                      <ul className="charge-details">
                        <li>Id: {charge.id}</li>
                        <li>Name: {charge.name}</li>
                        <li>Description: {charge.description}</li>
                        <li>Beneficiary Type Id: {charge.beneficiaryTypeId}</li>
                        <li>Deduction Type Id: {charge.deductionTypeId}</li>
                        <li>Charge Type: {charge.chargeType}</li>
                        <li>Value Type: {charge.valueType}</li>
                        <li>Value: {charge.value}</li>
                        <li>Value Min: {charge.valueMin}</li>
                        <li>Value Max: {charge.valueMax}</li>
                      </ul>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>

            <Box className="action-buttons">
              <Button variant="outline-secondary" onClick={goback} className="back-btn">
                Back
              </Button>
              <Button variant="success" onClick={props.handleAddNeweMapCharges} className="save-btn">
                Save
              </Button>
            </Box>
          </div>
        </div>
      )}
    </>
  );
};